export const EVENT_LOG_URL = 'https://analytics.lunait.io/log-event';export const EVENT_LOG_API_KEY = 'V6pkX3F-G7sIbVXQ4j0t769MOk1wb7Zz90zex8ob_QP';
